import { useEffect, useRef, useState } from 'react';

// Teks yang otomatis jadi marquee (scroll + fade di tepi) kalau kepanjangan
// buat muat di container-nya; kalau muat, tampil statis biasa. Dipakai buat
// pill logo mobile supaya nggak makan banyak ruang tapi teksnya tetap kebaca
// penuh walau nama brand-nya panjang.
export default function MarqueeText({ text, className = '' }) {
  const containerRef = useRef(null);
  const measureRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const check = () => {
      if (containerRef.current && measureRef.current) {
        setOverflowing(measureRef.current.scrollWidth > containerRef.current.clientWidth + 1);
      }
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [text]);

  return (
    <div ref={containerRef} className={`relative overflow-hidden ${overflowing ? 'marquee-fade' : ''}`}>
      {/* Salinan tersembunyi cuma buat ukur lebar asli teksnya */}
      <span ref={measureRef} className={`whitespace-nowrap absolute opacity-0 pointer-events-none -z-10 ${className}`} aria-hidden="true">
        {text}
      </span>

      {overflowing ? (
        <div className="marquee-track">
          <span className={`marquee-item ${className}`}>{text}</span>
          <span className={`marquee-item ${className}`} aria-hidden="true">{text}</span>
        </div>
      ) : (
        <span className={`whitespace-nowrap block ${className}`}>{text}</span>
      )}
    </div>
  );
}